if (!customElements.get('yc-promotion-modal')) {
  class YcPromotionModal extends HTMLElement {
    connectedCallback() {
      const settingsStr = this.getAttribute('data-settings');
      this.settings = settingsStr ? JSON.parse(settingsStr) : {};
      
      this.modal = this.querySelector('.yc-promotion-modal');
      this.closeBtn = this.querySelector('.yc-promotion-modal__close');
      
      this.init();
    }

    init() {
      if (!this.modal) return;

      const delay = (this.settings.show_delay || 0) * 1000;
      const previewMode = Boolean(this.settings.preview_mode);
      const isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;
      const displayFrequency = this.settings.display_frequency || 'once';

      // 如果设置为仅首次显示，且当前会话已经展示过，则不再展示
      if (!previewMode && !isDesignMode && displayFrequency === 'once' && sessionStorage.getItem('yc_promotion_modal_shown') === 'true') {
        return;
      }

      if (previewMode) {
        this.open();
      } else if (!isDesignMode) {
        // 只有在非编辑器模式下，才执行延迟自动弹出的逻辑
        window.setTimeout(() => {
          this.open();
        }, delay);
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }

      // 点击商品卡片链接时关闭弹窗
      const productLinks = this.modal.querySelectorAll('.yc-promotion-modal__product-link[href]');
      productLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          if (isDesignMode) {
            e.preventDefault(); // 防止在编辑器中点击链接导致页面重定向报错
          }
          this.close(true); // 强制关闭，即使在预览模式下
        });
      });

      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) {
          this.close();
        }
      });
      
      this.handleEscape = (e) => {
        if (e.key === 'Escape' && this.modal.classList.contains('is-open')) {
          this.close();
        }
      };
      document.addEventListener('keydown', this.handleEscape);
    }
    
    open() {
      this.modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      
      if (this.settings.display_frequency === 'once') {
        sessionStorage.setItem('yc_promotion_modal_shown', 'true');
      }
    }
    
    close(force = false) {
      if (this.settings.preview_mode && !force) return;
      this.modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    
    disconnectedCallback() {
      document.removeEventListener('keydown', this.handleEscape);
    }
  }
  
  customElements.define('yc-promotion-modal', YcPromotionModal);
}
